import { AppBar, Box, ClickAwayListener, IconButton, styled, Toolbar, useMediaQuery, Typography, useTheme } from "@mui/material";
import { SettingsContext } from "contexts/settingsContext";
import MenuLeft from "icons/MenuLeft";
import MenuLeftRight from "icons/MenuLeftRight";
import SearchIcon from "icons/SearchIcon";
import ThemeIcon from "icons/ThemeIcon";
import { Fragment, useContext, useState, useEffect } from "react";
import LanguagePopover from "./popovers/LanguagePopover";
import NotificationsPopover from "./popovers/NotificationsPopover";
import ProfilePopover from "./popovers/ProfilePopover";
import ServicePopover from "./popovers/ServicePopover";
import SearchBar from "./SearchBar"; // ------------------------------------------------
import { usePageTitle } from 'contexts/PageTitleContext';

// ------------------------------------------------
// custom styled components
const DashboardHeaderRoot = styled(AppBar)(({
  theme
}) => ({
  zIndex: 11,
  boxShadow: "none",
  paddingTop: "1rem",
  paddingBottom: "1rem",
  backdropFilter: "blur(6px)",
  backgroundColor: "transparent",
  color: theme.palette.text.primary
}));
const StyledToolBar = styled(Toolbar)(() => ({
  "@media (min-width: 0px)": {
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: "auto"
  }
}));
const StyledIconButton = styled(IconButton)(({
  theme
}) => ({
  "&:hover": {
    backgroundColor: theme.palette.action.hover
  }
}));
const ToggleIcon = styled(Box)(({
  theme,
  width
}) => ({
  height: 3,
  margin: "5px",
  marginLeft: 0,
  width: width || 25,
  borderRadius: "10px",
  transition: "width 0.3s",
  backgroundColor: theme.palette.primary.main
}));

const DashboardHeader = props => {
  const {
    setShowMobileSideBar,
    pageTitle = "Dashboard"
  } = props;
  const [openSearchBar, setSearchBar] = useState(false);
  const {
    settings,
    saveSettings
  } = useContext(SettingsContext);
  const upSm = useMediaQuery(theme => theme.breakpoints.up("sm"));
  const downMd = useMediaQuery(theme => theme.breakpoints.down(1200));
  const { pageTitle: contextPageTitle } = usePageTitle();
  const theme = useTheme();

  // Set dark mode by default when component mounts
  useEffect(() => {
    saveSettings({ ...settings, theme: 'light' });
    if (settings.theme === 'light') {
      saveSettings({ ...settings, theme: 'light' });
    }
  }, []);

  const handleChangeDirection = value => {
    saveSettings({ ...settings,
      direction: value
    });
  };

  const handleChangeTheme = value => {
    saveSettings({ ...settings,
      theme: value
    });
  };

  return <DashboardHeaderRoot position="sticky">
      <StyledToolBar>
        {downMd && <Box sx={{
        cursor: "pointer"
      }} onClick={setShowMobileSideBar}>
            <ToggleIcon />
            <ToggleIcon width={18} />
            <ToggleIcon width={9} />
          </Box>}

        {/* Enhanced Page Title */}
        <Box 
          sx={{ 
            ml: 2,
            display: 'flex',
            alignItems: 'center',
            position: 'relative'
          }}
        >
          <Typography 
            variant="h5" 
            sx={{ 
              fontWeight: 700,
              fontSize: '1.5rem',
              color: theme.palette.mode === 'dark' 
                ? theme.palette.primary.light 
                : theme.palette.primary.main,
              letterSpacing: '0.5px',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -4,
                left: 0,
                width: '40%',
                height: 3,
                backgroundColor: theme.palette.primary.main,
                borderRadius: '2px',
                transition: 'width 0.3s ease',
              },
              '&:hover::after': {
                width: '100%',
              },
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-1px)',
                textShadow: theme.palette.mode === 'dark'
                  ? '0 0 8px rgba(255, 255, 255, 0.2)'
                  : '0 0 8px rgba(0, 0, 0, 0.1)',
              }
            }}
          >
            {contextPageTitle}
          </Typography>

          {/* Optional: Breadcrumb or subtitle */}
          <Typography 
            variant="body2" 
            sx={{ 
              ml: 2,
              color: theme.palette.text.secondary,
              opacity: 0.8
            }}
          >
            {/* You can add breadcrumb or subtitle here if needed */}
          </Typography>
        </Box>

        <Box flexGrow={1} ml={1} />

        {/* {settings.direction === "rtl" ? <StyledIconButton onClick={() => handleChangeDirection("ltr")}>
            <MenuLeft sx={{
          color: "text.disabled"
        }} />
          </StyledIconButton> : <StyledIconButton onClick={() => handleChangeDirection("rtl")}>
            <MenuLeftRight sx={{
          color: "text.disabled"
        }} />
          </StyledIconButton>} */}

        {settings.theme === "light" ? <StyledIconButton onClick={() => handleChangeTheme("dark")}>
            <ThemeIcon />
          </StyledIconButton> : <StyledIconButton onClick={() => handleChangeTheme("light")}>
            <ThemeIcon />
          </StyledIconButton>}

        {upSm && <Fragment>
          </Fragment>}
        <ProfilePopover />
      </StyledToolBar>
    </DashboardHeaderRoot>;
};

export default DashboardHeader;